// import React from "react";
// import CountersAndWhyChooseUs from "../pages/CountersAndWhyChooseUs";
// import Testimonialsabout from "../pages/Testimonialsabout";

// const AboutUs = () => {
//   return (



// <>

// <div
//       className="breadcumb-wrapper"
      
//       data-overlay="black"
//       data-opacity="3"
//     >
//       <div className="container">
//         <div className="breadcumb-content text-center">
//           <h1 className="breadcumb-title">About Us</h1>
//         </div>
//       </div>
//     </div>

//     <div className="about-1-wrapper space" id="about-sec">
//       <div className="container">
//         {/* Top Section */}
//         <div className="row gy-40 gx-60 flex-wrap-reverse justify-content-center">
//           {/* Images */}
//           <div className="col-xl-7">
//             <div className="img-box1 about-2">
//               <div className="img1">
//                 <img
//                   className="tilt-active"
//                   src="/img/about/about-1.1-1.jpg"
//                   alt="About"
//                 />
//               </div>
//               <div className="img2">
//                 <img
//                   className="tilt-active"
//                   src="/img/about/about-1.1-2.jpg"
//                   alt="About"
//                 />
//               </div>
//               <div className="img3">
//                 <img
//                   src="/img/about/about-1.1-3.jpg"
//                   alt="About"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Content */}
//           <div className="col-xl-5">
//             <div className="title-area mb-25 ps-xl-4">
//               <span className="sub-title style-2">Welcome to Kars</span>
//               <h2 className="sec-title">
//                 About Us Our Auto Dealership Company
//               </h2>

//               <p className="sec-text">
//                 Our multi-brand trade-in program allows you to bring in your
//                 current vehicle, regardless of make or model, and receive a
//                 competitive trade-in value. This makes upgrading to a new car
//                 even easier and more affordable.
//               </p>

//               <p className="sec-text">
//                 We offer flexible payment plans to meet your financial needs and
//                 even provide tailored solutions for customers with various
//                 credit profiles.
//               </p>

//               <div className="client-bottom-wrap">
//                 <div className="client-wrap">
//                   <div className="thumb">
//                     <img
//                       src="/img/about/about-1.1-client.png"
//                       alt="Client"
//                     />
//                   </div>
//                   <div className="text-wrap">
//                     <h4 className="box-title">Rechard Smith Colin</h4>
//                     <p>CEO, Founder of Kars</p>
//                   </div>
//                 </div>
//                 <div className="sing-thumb">
//                   <img
//                     src="/img/about/about-1.1-sing.png"
//                     alt="Signature"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Counters */}
//         <div className="row justify-content-xl-end">
//           <div className="col-xl-8">
//             <div className="counter-card-wrap style-2-inner">
//               <div className="counter-card">
//                 <div className="box-icon">
//                   <img
//                     src="/img/icon/counter_1.1_1.svg"
//                     alt="Icon"
//                   />
//                 </div>
//                 <div className="media-body">
//                   <h4 className="box-number">
//                     <span className="counter-number">2760</span>
//                     <span className="plus-simple">+</span>
//                   </h4>
//                   <p className="box-text">Cars For Sale</p>
//                 </div>
//               </div>

//               <div className="counter-card">
//                 <div className="box-icon">
//                   <img
//                     src="/img/icon/counter_1.1_2.svg"
//                     alt="Icon"
//                   />
//                 </div>
//                 <div className="media-body">
//                   <h4 className="box-number">
//                     <span className="counter-number">300</span>
//                     <span className="plus-simple">+</span>
//                   </h4>
//                   <p className="box-text">Visitor Per Day</p>
//                 </div>
//               </div>

//               <div className="counter-card">
//                 <div className="box-icon">
//                   <img
//                     src="/img/icon/counter_1.1_3.svg"
//                     alt="Icon"
//                   />
//                 </div>
//                 <div className="media-body">
//                   <h4 className="box-number">
//                     <span className="counter-number">2660</span>
//                     <span className="plus-simple">+</span>
//                   </h4>
//                   <p className="box-text">Dealers Review</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>



// <CountersAndWhyChooseUs/>
// <Testimonialsabout/>
// </>
//   );
// };

// export default AboutUs;




import React from "react";
import CountersAndWhyChooseUs from "../pages/CountersAndWhyChooseUs";
import Testimonialsabout from "../pages/Testimonialsabout";
import UrbaniaVisionMission from "../pages/VisionMission";

const AboutUs = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        data-overlay="black"
        data-opacity="3"
      >
        <div className="container">
          <div className="breadcumb-content text-center">
            <h1 className="breadcumb-title">About Us</h1>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div className="about-1-wrapper py-5" id="about-sec">
        <div className="container">
          <div className="row gy-40 gx-60 flex-wrap-reverse justify-content-center">
            {/* Images */}
            <div className="col-xl-7">
              <div className="img-box1 about-2">
                <div className="img1">
                  <img
                    className="tilt-active"
                    src="/img/about/about-1.1-1.jpg"
                    alt="Urbania on Rent in Pune"
                  />
                </div>
                <div className="img2">
                  <img
                    className="tilt-active"
                    src="/images/gallery/2.jpg"
                    // src="/img/about/about-1.1-2.jpg"
                    alt="Urbania Rental Pune"
                  />
                </div>
                <div className="img3">
                  <img
                    src="/images/gallery/3.jpg"
                    alt="Luxury Urbania Bus Pune"
                  />
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="col-xl-5">
              <div className="title-area mb-25 ps-xl-4">
                <span className="sub-title style-2">
                  Welcome to Urbania Rental in Pune
                </span>

                <h2 className="sec-title">
                  Trusted Urbania on Rent in Pune for Group Travel
                </h2>

                {/* <p className="sec-text text-dark">
                  We provide premium Force Urbania on rent in Pune for local,
                  outstation, corporate, wedding, and tour travel. Our Urbania
                  vehicles are known for luxury interiors, spacious seating, and
                  superior ride comfort, making them ideal for group journeys.
                </p>

                <p className="sec-text text-dark">
                  With experienced drivers, transparent pricing, and 24×7
                  support, we ensure a smooth and stress-free travel experience.
                  Whether you need a 12, 14, or 17 seater Urbania, we offer
                  flexible rental options tailored to your travel needs.
                </p> */}

                
<p className="sec-text text-dark"> We offer premium Force Urbania rentals in Pune, designed to deliver a comfortable and luxurious travel experience for all types of journeys. Whether it’s local travel, outstation trips, corporate events, weddings, or group tours, our Urbania vehicles provide spacious seating, modern interiors, and a smooth ride—making them an ideal choice for group transportation. </p>

 <p className="sec-text text-dark"> Our service is backed by professional drivers, transparent pricing, and 24/7 customer support to ensure a hassle-free experience from start to finish. With flexible rental options for 12, 14, and 17-seater Urbania vehicles, we cater to diverse travel needs while maintaining high standards of safety, reliability, and customer satisfaction. </p>

                {/* <div className="client-bottom-wrap">
                  <div className="client-wrap">
                    <div className="thumb">
                      <img
                        src="/img/about/about-1.1-client.png"
                        alt="Founder"
                      />
                    </div>
                    <div className="text-wrap">
                      <h4 className="box-title">Mr. Aaryan Patil</h4>
                      <p>Founder – Urbania Rental Pune</p>
                    </div>
                  </div>

                  <div className="sing-thumb">
                    <img
                      src="/img/about/about-1.1-sing.png"
                      alt="Signature"
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          {/* Counters */}
          <div className="row justify-content-xl-end">
            <div className="col-xl-8">
              <div className="counter-card-wrap style-2-inner">
                <div className="counter-card">
                  <div className="box-icon">
                    <img
                      src="/img/icon/counter_1.1_1.svg"
                      alt="Urbania Trips"
                    />
                  </div>
                  <div className="media-body">
                    <h4 className="box-number">
                      <span className="counter-number">3100</span>
                      <span className="plus-simple">+</span>
                    </h4>
                    <p className="box-text">Urbania Trips Completed</p>
                  </div>
                </div>

                <div className="counter-card">
                  <div className="box-icon">
                    <img
                      src="/img/icon/counter_1.1_2.svg"
                      alt="Customers"
                    />
                  </div>
                  <div className="media-body">
                    <h4 className="box-number">
                      <span className="counter-number">5650</span>
                      <span className="plus-simple">+</span>
                    </h4>
                    <p className="box-text">Happy Customers</p>
                  </div>
                </div>

                <div className="counter-card">
                  <div className="box-icon">
                    <img
                      src="/img/icon/counter_1.1_3.svg"
                      alt="Experience"
                    />
                  </div>
                  <div className="media-body">
                    <h4 className="box-number">
                      <span className="counter-number">10</span>
                      <span className="plus-simple">+</span>
                    </h4>
                    <p className="box-text">Years of Experience</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<UrbaniaVisionMission/>
      {/* Extra Sections */}
      <CountersAndWhyChooseUs />
      <Testimonialsabout />
    </>
  );
};

export default AboutUs;
